'use client'

import { useTranslations } from 'next-intl'
import { WifiOff } from 'lucide-react'
import { useNetworkStatus } from '@/hooks/use-network-status'

/**
 * Network status banner for native apps.
 * Shows a slim, non-intrusive banner at the top when offline.
 * Pattern from Slack, LinkedIn, WhatsApp.
 * Detection lives in `useNetworkStatus` (shared with the Encuentro banner).
 */
export function NetworkStatusBanner() {
  const t = useTranslations('common')
  const { isOffline, isNative } = useNetworkStatus()

  // Only show on native apps — web browsers (including localhost)
  // handle offline state natively, and navigator.onLine can false-positive
  if (!isOffline || !isNative) return null

  return (
    <div className={`fixed top-0 left-0 right-0 z-9999 ${isNative ? 'pt-safe' : ''}`}>
      <div className="bg-red-600 text-white text-xs font-medium py-1.5 px-4 flex items-center justify-center gap-2 shadow-md">
        <WifiOff className="w-3.5 h-3.5" />
        <span>{t('noInternet')}</span>
      </div>
    </div>
  )
}
